app.filter("criteria", function($sce, odmRecommendService) {
	return function (msgdata) {
		var htmlstr = "";
		var dmEnables = odmRecommendService.getMsgEnables();
		if( msgdata != null ) {
			var enablecnt = 0;
			for( var i = 0; i < msgdata.length; i++ ) {
                if( dmEnables[msgdata[i].category] ) {
					htmlstr += msgdata[i].observation + ",";
				}
				else {
					htmlstr += "未入力,";
				}
			};
			htmlstr = htmlstr.slice( 0, -1 );
		}
		return $sce.trustAsHtml( htmlstr );
	};
});
